import { useQuery } from '@tanstack/react-query';

import { AppsClient } from './apps-client';

import { api } from '@/lib/api';

export default function ProjectsPage(): import('react/jsx-runtime').JSX.Element {
  const { data: orgsData } = useQuery({
    queryKey: ['organizations'],
    queryFn: () => api.listOrganizations(),
    staleTime: 5 * 60 * 1000,
  });

  const { data: projectsData } = useQuery({
    queryKey: ['projects'],
    queryFn: () => api.listProjects(),
    staleTime: 60 * 1000,
  });

  return (
    <AppsClient
      initialProjects={projectsData?.projects ?? []}
      orgs={orgsData?.organizations ?? []}
    />
  );
}
